
export const init = (survey: any) => {
  const extrarecipient = {
    name: 'extrarecipient',
    title: 'Extra Recipient',
    iconName: '',
    widgetIsLoaded: () => true,

    isFit: (question) => question.getType() === 'extrarecipient',

    activatedByChanged: (activatedBy) => {
      survey.JsonObject.metaData.addClass('extrarecipient', [], null, 'text');

      survey.JsonObject.metaData.addProperties('extrarecipient', [
        { name: 'emailTo:string', default: 'to', choices: ['to', 'cc', 'bcc'] },
      ]);
    },

    isDefaultRender: false,
    htmlTemplate: '<div><input type="text" id="extrarecipient" name="extrarecipient" class="sv-text"></div>',

    afterRender: (question, el) => {
      const text = el.getElementsByTagName('input')[0];

      text.onchange = () => {
        question.value = text.value;
      };
      const onValueChangedCallback = () => {
        text.value = question.value ? question.value : '';
      };
      const onReadOnlyChangedCallback = () => {
      };
      question.readOnlyChangedCallback = onReadOnlyChangedCallback;
      question.valueChangedCallback = onValueChangedCallback;
      onValueChangedCallback();
      onReadOnlyChangedCallback();
    },
   
  };

  survey.CustomWidgetCollection.Instance.addCustomWidget(extrarecipient, 'customtype');
};

